import React from 'react';
import { MapbookFrame } from 'apps/Results/common/MapbookFrame';

import { FieldType } from 'store/fields/types';
import { PrescriptionType } from 'store/prescriptions/types';

import PrescriptionSummary from './PrescriptionSummary';
import PrescriptionThumbnail from './PrescriptionThumbnail';

interface PrescriptionListPropsType {
  fieldGeometry: FieldType;
  prescription: PrescriptionType;
  cancelPrescription: (script: PrescriptionType) => void;
  checked?: boolean;
  onChecked?: () => void;
}

const PrescriptionMapbook = ({
  prescription,
  fieldGeometry,
  cancelPrescription,
  checked,
  onChecked,
}: PrescriptionListPropsType) => {
  return (
    <MapbookFrame
      key={prescription.id}
      summaryContent={
        <PrescriptionSummary
          field={fieldGeometry}
          prescription={prescription}
          cancelPrescription={cancelPrescription}
          checked={checked}
          onChecked={onChecked}
        />
      }
      mapContent={<PrescriptionThumbnail field={fieldGeometry} prescription={prescription} />}
    />
  );
};

export default PrescriptionMapbook;
